/* eslint-disable react/button-has-type, jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary, jsx-a11y/no-autofocus, react/no-unescaped-entities */
/* eslint-disable no-unused-vars, no-useless-return, curly, nonblock-statement-body-position */
/* eslint-disable no-confusing-arrow */
import React, { useState, useEffect, useCallback } from 'react';
import { SUB_SCREENS, DEP_INIT } from '../../constants';
import { CloseIcon, TableActions, F } from '../CommonUI';
import { apiCall } from '../../utils/api';
import EmployeeMasterDeleteConfirm from './EmployeeMasterDeleteConfirm';

/**
 * Dependents Sub-Screen
 * ┌──────────────────────────────────────────────────────────────┐
 * │  GET    /api/dependents/:empCode        → [{ id, ... }]     │
 * │  POST   /api/dependents/:empCode        → { id, ... }       │
 * │  PUT    /api/dependents/:empCode/:id    → { success }       │
 * │  DELETE /api/dependents/:empCode/:id    → { success }       │
 * └──────────────────────────────────────────────────────────────┘
 */
function DependentsScreen({ empName, empCode, onClose, opts, readOnly }) {
  const [deps, setDeps] = useState([]);
  const [form, setForm] = useState({ ...DEP_INIT });
  const [editing, setEditing] = useState(null);
  const [editingSrNo, setEditingSrNo] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const clean = value => (typeof value === 'string' ? value.trim() : value);
  const toInputDate = value => (value ? String(value).slice(0, 10) : '');
  const normalizeSrNo = value => {
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : 0;
  };
  const pickFirst = (...values) =>
    values.find(v => v !== undefined && v !== null && v !== '');
  const getOptionLabel = (options, rawValue) => {
    const value = clean(rawValue);
    if (!value) return '';
    if (!Array.isArray(options) || options.length === 0) return value;
    const matched = options.find(opt => {
      if (typeof opt === 'object' && opt !== null) {
        return clean(opt.value) === value;
      }
      return clean(opt) === value;
    });
    if (!matched) return value;
    if (typeof matched === 'object' && matched !== null) {
      return clean(matched.label) || value;
    }
    return clean(matched) || value;
  };
  const mapDependentFromApi = useCallback(
    dep => ({
      id: normalizeSrNo(pickFirst(dep?.SrNo, dep?.srNo, dep?.SRNO)),
      srNo: normalizeSrNo(pickFirst(dep?.SrNo, dep?.srNo, dep?.SRNO)),
      relationship: clean(pickFirst(dep?.Reln, dep?.reln, dep?.RELN)) || '',
      relName: clean(pickFirst(dep?.Name, dep?.name, dep?.NAME)) || '',
      dob: toInputDate(pickFirst(dep?.DOB, dep?.dob)),
      nationality:
        clean(
          pickFirst(dep?.Nationality, dep?.nationality, dep?.NATIONALITY),
        ) || '',
      ticketsPerYear:
        pickFirst(dep?.FareFreq, dep?.fareFreq, dep?.FAREFREQ) === null ||
        pickFirst(dep?.FareFreq, dep?.fareFreq, dep?.FAREFREQ) === undefined
          ? ''
          : String(
              clean(pickFirst(dep?.FareFreq, dep?.fareFreq, dep?.FAREFREQ)),
            ),
      ticketEligibleFrom: toInputDate(
        pickFirst(dep?.FareEligibleDt, dep?.fareEligibleDt),
      ),
      nationalId:
        clean(pickFirst(dep?.NationalId, dep?.nationalId, dep?.NATIONALID)) ||
        '',
      passportNo: clean(pickFirst(dep?.PPNo, dep?.ppNo, dep?.PPNO)) || '',
      issueDate: toInputDate(pickFirst(dep?.PPIssueDt, dep?.ppIssueDt)),
      expiryDate: toInputDate(pickFirst(dep?.PPExpDt, dep?.ppExpDt)),
      issuePlace:
        clean(
          pickFirst(dep?.PPIssueplace, dep?.ppIssueplace, dep?.PPIssuePlace),
        ) || '',
      visaNo: clean(pickFirst(dep?.VisaNo, dep?.visaNo, dep?.VISANO)) || '',
      fileNo: clean(pickFirst(dep?.FileNo, dep?.fileNo, dep?.FILENO)) || '',
      visaIssueDate: toInputDate(pickFirst(dep?.VisaIssueDt, dep?.visaIssueDt)),
      visaExpiryDate: toInputDate(pickFirst(dep?.VisaExpDt, dep?.visaExpDt)),
    }),
    [],
  );

  const fetchDependents = useCallback(() => {
    if (!empCode) return;
    const req = apiCall('/envision/api/employee/get-dependents', {
      method: 'POST',
      body: { empCd: empCode },
    });
    if (!req) return;
    setLoading(true);
    return req
      .then(data => {
        const list = Array.isArray(data?.result)
          ? data.result.map(mapDependentFromApi)
          : [];
        setDeps(list);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to load dependents.');
        setLoading(false);
      });
  }, [empCode, mapDependentFromApi]);

  useEffect(() => {
    fetchDependents();
  }, [fetchDependents]);

  useEffect(() => {
    if (readOnly) {
      setShowForm(false);
      setEditing(null);
    }
  }, [readOnly]);

  const cf = (n, v) => {
    if (n === 'ticketsPerYear') {
      if (v === '' || v === null || v === undefined) {
        setForm(p => ({ ...p, [n]: v }));
        return;
      }
      const num = Number(v);
      if (!Number.isNaN(num)) {
        const clamped = Math.min(2, Math.max(0, Math.round(num)));
        setForm(p => ({ ...p, [n]: String(clamped) }));
        return;
      }
    }
    setForm(p => ({ ...p, [n]: v }));
  };
  const toIsoDate = value =>
    value ? new Date(`${value}T00:00:00.000Z`).toISOString() : null;
  const resetForm = () => {
    setForm({ ...DEP_INIT });
    setShowForm(false);
    setEditing(null);
    setEditingSrNo(0);
  };

  const doSave = () => {
    const mandatory = [
      'relationship',
      'relName',
      'dob',
      'nationality',
      'ticketsPerYear',
      'ticketEligibleFrom',
    ];
    const missing = mandatory.find(f => !form[f]);
    if (missing) {
      const el = document.getElementById(`f-${missing}`);
      if (el) el.focus();
      return;
    }

    const tickets = Number(form.ticketsPerYear);
    if (Number.isNaN(tickets) || tickets < 0 || tickets > 2) {
      setError('Tickets/Year must be between 0 and 2.');
      const el = document.getElementById('f-ticketsPerYear');
      if (el) el.focus();
      return;
    }
    setError(null);

    const currentSrNo =
      editing !== null
        ? normalizeSrNo(
            editingSrNo ??
              form?.srNo ??
              form?.id ??
              deps[editing]?.srNo ??
              deps[editing]?.id ??
              0,
          )
        : 0;

    const payload = {
      employeeId: empCode,
      srNo: currentSrNo,
      reln: form.relationship,
      name: form.relName,
      dob: toIsoDate(form.dob),
      nationality: form.nationality,
      fareEligible: 'Y',
      fareEligibleDt: toIsoDate(form.ticketEligibleFrom),
      fareFreq: String(form.ticketsPerYear || ''),
      nationalId: form.nationalId || '',
      ppNo: form.passportNo || '',
      ppIssueDt: toIsoDate(form.issueDate),
      ppExpDt: toIsoDate(form.expiryDate),
      ppIssueplace: form.issuePlace || '',
      visaNo: form.visaNo || '',
      fileNo: form.fileNo || '',
      visaIssueDt: toIsoDate(form.visaIssueDate),
      visaExpDt: toIsoDate(form.visaExpiryDate),
    };

    const req = apiCall('/envision/api/employee/create-dependents', {
      method: 'POST',
      body: payload,
    });
    if (req) {
      req
        .then(data => {
          const resultPayload = Array.isArray(data?.result)
            ? data.result[0]
            : data?.result;
          const returnedSrNo = normalizeSrNo(
            pickFirst(
              data?.srNo,
              data?.SrNo,
              data?.SRNO,
              resultPayload?.srNo,
              resultPayload?.SrNo,
              resultPayload?.SRNO,
            ),
          );
          const savedSrNo = returnedSrNo || currentSrNo;
          if (editing !== null) {
            setDeps(p =>
              p.map((d, i) =>
                i === editing
                  ? {
                      ...form,
                      id: d.id || deps[editing].id || savedSrNo,
                      srNo: savedSrNo,
                    }
                  : d,
              ),
            );
          } else {
            setDeps(p => [
              ...p,
              {
                ...form,
                id:
                  data?.id ||
                  data?.Id ||
                  data?.ID ||
                  data?.result?.id ||
                  data?.result?.Id ||
                  data?.result?.ID ||
                  savedSrNo,
                srNo: savedSrNo,
              },
            ]);
          }
          return fetchDependents();
        })
        .then(() => {
          resetForm();
        })
        .catch(() => {
          setError('Failed to save.');
        });
    } else {
      if (editing !== null)
        setDeps(p => p.map((d, i) => (i === editing ? { ...form } : d)));
      else setDeps(p => [...p, { ...form }]);
      resetForm();
    }
  };
  const doEdit = i => {
    const rowSrNo = normalizeSrNo(deps[i]?.srNo ?? deps[i]?.id ?? 0);
    setEditingSrNo(rowSrNo);
    setForm({ ...deps[i], srNo: rowSrNo, id: rowSrNo });
    setEditing(i);
    setShowForm(true);
  };
  const openDeleteConfirm = i => {
    setDeleteIndex(i);
    setDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    if (deleteLoading) return;
    setDeleteModalOpen(false);
    setDeleteIndex(null);
  };

  const performDelete = () => {
    if (deleteIndex == null) return;
    const i = deleteIndex;

    const finishOk = () => {
      setDeleteLoading(false);
      setDeleteModalOpen(false);
      setDeleteIndex(null);
    };

    const req = apiCall('/envision/api/employee/delete-dependents', {
      method: 'POST',
      body: {
        empCd: empCode,
        srNo: deps[i]?.srNo ?? deps[i]?.id,
      },
    });
    if (req) {
      setDeleteLoading(true);
      req
        .then(() => {
          setDeps(p => p.filter((_, j) => j !== i));
          finishOk();
        })
        .catch(() => {
          setError('Failed to delete.');
          setDeleteLoading(false);
        });
    } else {
      setDeps(p => p.filter((_, j) => j !== i));
      finishOk();
    }
  };

  return (
    <div className="ov">
      <div
        className="sub-modal sub-modal-lg"
        onClick={e => e.stopPropagation()}
      >
        <div className="sub-modal-top comp-modal-top">
          <div className="sub-modal-title">
            <div className="sub-modal-title-row sub-modal-title-row--stacked comp-modal-title-row">
              <span className="sub-modal-icon sub-modal-icon--lg comp-modal-icon-shell">
                <span className="comp-modal-icon-inner">
                  {SUB_SCREENS[3].icon}
                </span>
              </span>
              <div className="sub-modal-title-block">
                <h2>Dependents</h2>
                {empCode && (
                  <span className="sub-modal-emp sub-modal-emp--stacked">
                    {[empName, empCode].filter(Boolean).join(' \u00b7 ')}
                  </span>
                )}
              </div>
            </div>
          </div>
          <button className="mdl-x" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="sub-modal-body">
          {error && (
            <div
              style={{
                padding: '12px 20px',
                background: 'var(--red-l)',
                color: 'var(--red)',
                fontSize: 13,
                fontWeight: 500,
                marginBottom: 12,
                borderRadius: 'var(--r)',
              }}
            >
              {error}
            </div>
          )}
          {loading ? (
            <div className="sub-empty">
              <span>Loading dependents...</span>
            </div>
          ) : (
            <>
              {deps.length > 0 && (
                <div className="dep-table-wrap">
                  <table className="dep-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Relationship</th>
                        <th>Name</th>
                        <th>Nationality</th>
                        <th>Passport No.</th>
                        <th>D.O.B</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deps.map((dep, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>
                            {getOptionLabel(opts?.relation, dep.relationship)}
                          </td>
                          <td>{dep.relName}</td>
                          <td>
                            {getOptionLabel(opts?.nationality, dep.nationality)}
                          </td>
                          <td>{dep.passportNo}</td>
                          <td>
                            {dep.dob && dep.dob.includes('-')
                              ? dep.dob.split('-').reverse().join('/')
                              : dep.dob || '—'}
                          </td>
                          <td>
                            <TableActions
                              readOnly={readOnly}
                              onEdit={() => doEdit(i)}
                              onDelete={() => openDeleteConfirm(i)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {showForm && !readOnly ? (
                <div className="dep-form">
                  <div className="dep-form-title">
                    {editing !== null ? 'Edit Dependent' : 'Add New Dependent'}
                  </div>
                  <div className="dep-sections">
                    <div className="dep-sec">
                      <div className="dep-sec-h">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                          <circle
                            cx="12"
                            cy="7"
                            r="4"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                        Personal Details
                      </div>
                      <div className="dep-sec-grid dep-sec-grid-4">
                        <F
                          label="Relationship"
                          name="relationship"
                          value={form.relationship}
                          onChange={cf}
                          options={opts?.relation}
                          required
                        />
                        <F
                          label="Relation's Name"
                          name="relName"
                          value={form.relName}
                          onChange={cf}
                          required
                        />
                        <F
                          label="D.O.B"
                          name="dob"
                          type="date"
                          value={form.dob}
                          onChange={cf}
                          required
                        />
                        <F
                          label="Nationality"
                          name="nationality"
                          value={form.nationality}
                          onChange={cf}
                          options={opts?.nationality}
                          required
                        />
                        <F
                          label="Tickets/Year"
                          name="ticketsPerYear"
                          type="number"
                          value={form.ticketsPerYear}
                          onChange={cf}
                          required
                          min={0}
                          max={2}
                          step={1}
                        />
                        <F
                          label="Ticket Eligible From"
                          name="ticketEligibleFrom"
                          type="date"
                          value={form.ticketEligibleFrom}
                          onChange={cf}
                          required
                        />
                        <F
                          label="National Id"
                          name="nationalId"
                          value={form.nationalId}
                          onChange={cf}
                        />
                      </div>
                    </div>
                    <div className="dep-sec">
                      <div className="dep-sec-h">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            x="2"
                            y="3"
                            width="20"
                            height="18"
                            rx="2"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <circle
                            cx="12"
                            cy="11"
                            r="3"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M7 17.5c0-2 2.24-3.5 5-3.5s5 1.5 5 3.5"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                        Passport Details
                      </div>
                      <div className="dep-sec-grid dep-sec-grid-4">
                        <F
                          label="Passport No."
                          name="passportNo"
                          value={form.passportNo}
                          onChange={cf}
                        />
                        <F
                          label="Issue Date"
                          name="issueDate"
                          type="date"
                          value={form.issueDate}
                          onChange={cf}
                        />
                        <F
                          label="Expiry Date"
                          name="expiryDate"
                          type="date"
                          value={form.expiryDate}
                          onChange={cf}
                        />
                        <F
                          label="Issue Place"
                          name="issuePlace"
                          value={form.issuePlace}
                          onChange={cf}
                          options={opts?.issuePlace}
                        />
                      </div>
                    </div>
                    <div className="dep-sec">
                      <div className="dep-sec-h">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M14 2v6h6"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                        </svg>
                        Visa Details
                      </div>
                      <div className="dep-sec-grid dep-sec-grid-4">
                        <F
                          label="Visa No."
                          name="visaNo"
                          value={form.visaNo}
                          onChange={cf}
                        />
                        <F
                          label="File No"
                          name="fileNo"
                          value={form.fileNo}
                          onChange={cf}
                        />
                        <F
                          label="Visa Issue Date"
                          name="visaIssueDate"
                          type="date"
                          value={form.visaIssueDate}
                          onChange={cf}
                        />
                        <F
                          label="Visa Expiry Date"
                          name="visaExpiryDate"
                          type="date"
                          value={form.visaExpiryDate}
                          onChange={cf}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="dep-form-actions">
                    <button className="btn em-btn" onClick={resetForm}>
                      Cancel
                    </button>
                    <button className="btn em-btn em-btn-p" onClick={doSave}>
                      {editing !== null ? 'Update' : 'Save'}
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ marginTop: deps.length > 0 ? 16 : 0 }}>
                  {deps.length === 0 && (
                    <div className="sub-empty">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
                          stroke="#cbd5e1"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="9"
                          cy="7"
                          r="4"
                          stroke="#cbd5e1"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
                          stroke="#cbd5e1"
                          strokeWidth="1.5"
                        />
                      </svg>
                      <span>No dependents found.</span>
                    </div>
                  )}
                  {!readOnly && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 16,
                      }}
                    >
                      <button
                        className="btn em-btn em-btn-p"
                        onClick={() => setShowForm(true)}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 5v14m-7-7h14"
                            stroke="#fff"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                          />
                        </svg>
                        Add Dependent
                      </button>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <EmployeeMasterDeleteConfirm
        isOpen={deleteModalOpen}
        toggle={closeDeleteModal}
        onConfirm={performDelete}
        loading={deleteLoading}
        message={
          deleteIndex != null && deps[deleteIndex] ? (
            <>
              Are you sure you want to delete dependent{' '}
              <span className="em-delete-confirm__highlight">
                {deps[deleteIndex].relName || '—'}
              </span>
              ?
            </>
          ) : null
        }
      />
    </div>
  );
}

export default DependentsScreen;
